export const ridesListStyle = {
  marginTop: -10,
  marginBottom: -10,
};
